import { render, staticRenderFns } from "./Lumio.vue?vue&type=template&id=c85cdac0"
import script from "./Lumio.vue?vue&type=script&lang=js"
export * from "./Lumio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports